import React, { useEffect, useState } from "react";
import VisitorForm from "./VisitorForm";
import axios from "axios";
import ExhibitorDashboardNavbar from "../exhibitor/exhibitor_dashboard/ExhibitorDashboardNavbar";
import { useNavigate } from "react-router-dom";

const ExhibitorStaff = () => {
  const [show, setShow] = useState(true);
  const navigate = useNavigate();
  const exhibitorAgentType = localStorage.getItem("exhibitor_agent_type");

  useEffect(() => {
    const fetchData = async () => {
      await axios
      .get(`${process.env.REACT_APP_API_END_POINT}/get-registration-visibility`)
      .then((res) => {
        console.log(
          "here is data come from 32 line of the  registration setting ",
          res.data
        );
        // setExhibitorStaff(res.data.exhibitor_staff);
        if (res.data.data.exhibitor_staff === "active") {
          setShow(true);
        } else {
          setShow(false);
        }
        // setExhibitorVip(res.data.exhibitor_vip);
        // setVisitor(res.data.visitor);
        // setVendorStaff(res.data.vendor_staff);
        // setVendorOwner(res.data.vendor_owner);
        // localStorage.setItem("exhibitorStaff", res.data.data.exhibitor_staff);
        // localStorage.setItem("exhibitorOwner", res.data.data.exhibitor_owner);
        // localStorage.setItem("exhibitorVip", res.data.data.exhibitor_vip);
        // localStorage.setItem("visitor", res.data.data.visitor);
        // localStorage.setItem("vendorStaff", res.data.data.vendor_staff);
        // localStorage.setItem("vendorOwner", res.data.data.vendor_owner);
      })
      .catch((err) => {
        // LoginRedirection("/superadmin/login");
        if (err.response && err.response.status === 401) {
          navigate("/superadmin/login");
          localStorage.removeItem("jff_token");
          localStorage.removeItem("category");
          localStorage.removeItem("permission");
          localStorage.removeItem("user_id");
          localStorage.removeItem("type_of_user");
        }
      });

    // await axios
    //   .post(`${process.env.REACT_APP_API_END_POINT}/get-exhibitor-name`, "", {
    //     headers: {
    //       token: localStorage.getItem("jff_token"),
    //     },
    //   })
    //   .then((res) => {
    //     setShow(!res?.data?.can_add_buyer);
    //   })
    //   .catch((err) => {
    //     if (err.response.status === 401) {
    //       navigate(`/${exhibitorAgentType.toLowerCase()}/login`);
    //       localStorage.removeItem("jff_token");
    //       localStorage.removeItem("category");
    //       localStorage.removeItem("permission");
    //       localStorage.removeItem("user_id");
    //       localStorage.removeItem("type_of_user");
    //     }
    //   });
    };
    fetchData();
  }, []);
  console.log(
    "asasdddaddssdasdasdsads",
    localStorage.getItem("exhibitorStaff")
  );
  return (
    <>
      <ExhibitorDashboardNavbar />
      {show ? (
        <VisitorForm
          formHeader={"Exhibitor staff registration"}
          formName={"exhibitor_staff"}
          barcodeId={""}
        />
      ) : (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="alert alert-warning text-center" role="alert">
            <strong>Form is suspended</strong>
          </div>
        </div>
      )}
    </>
  );
};

export default ExhibitorStaff;
